import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { AdminsList, CreateAdminsUserDialog } from "@/features/admins";
import { useAuth } from "@/features/auth";
import { HeadTitle } from "@/shared";
import { useAdminUsers } from "@/shared/hooks";

export default function AdminsPage() {
	const [openCreateAdminUserDialog, setOpenCreateAdminUserDialog] = useState(false);
	const { users, loading, refetch } = useAdminUsers();
	const handleOpen = () => setOpenCreateAdminUserDialog(true);
	const handleCloseCreateAdminUserDialog = () => setOpenCreateAdminUserDialog(false);
	const { usergroup } = useAuth();

	return (
		<Box sx={{ display: "flex", justifyContent: "center" }}>
			<HeadTitle pageTitle="ユーザー管理" />
			<Box sx={{ width: "80%", height: "75vh", display: "flex", flexDirection: "column" }}>
				<Typography component="h2" variant="h6" sx={{ fontWeight: "bold" }}>
					ユーザー
				</Typography>

				{usergroup === "管理者" && (
					<Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
						<Button variant="contained" color="primary" onClick={handleOpen}>
							＋ 新規ユーザーを追加
						</Button>
					</Box>
				)}

				<Box>
					<AdminsList userList={users} loading={loading} onEditUser={refetch} />
				</Box>
			</Box>

			<CreateAdminsUserDialog
				open={openCreateAdminUserDialog}
				handleClose={handleCloseCreateAdminUserDialog}
				onCreateUser={refetch}
			/>
		</Box>
	);
}
